export default {"src":"https://cdn.tanzhi.cn/_next/static/media/market.2c025c0a.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};